/**
 * PlannerHeader – The amber "Family Learning Planner" header bar.
 */
export function PlannerHeader({ parent, onLogout }) {
  const today = new Date();
  const dateStr = today.toLocaleDateString("en-AU", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <header className="bg-amber-800 text-white px-4 sm:px-6 py-3 sm:py-4 shadow-lg relative overflow-hidden">
      {/* Subtle diamond pattern overlay */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0L60 30L30 60L0 30z' fill='%23ffffff' fill-opacity='0.1'/%3E%3C/svg%3E\")",
        }}
      />
      <div className="max-w-7xl mx-auto flex items-center justify-between relative z-10">
        {/* Left: logo + title */}
        <div className="flex items-center gap-2 sm:gap-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-100 rounded-lg flex items-center justify-center shadow-inner flex-shrink-0">
            <span className="font-handwritten text-xl sm:text-2xl text-amber-800">Sw</span>
          </div>
          <div>
            <h1 className="font-handwritten text-xl sm:text-3xl">Family Learning Planner</h1>
            <p className="text-amber-200 text-xs sm:text-sm hidden sm:block">SpellWise Dashboard</p>
          </div>
        </div>

        {/* Right: welcome + avatar */}
        <div className="flex items-center gap-2 sm:gap-4">
          <div className="text-right hidden sm:block">
            <p className="font-medium">Welcome back, {parent?.name || "Parent"}</p>
            <p className="text-amber-200 text-sm">{dateStr}</p>
          </div>
          <div className="w-8 h-8 sm:w-10 sm:h-10 bg-amber-600 rounded-full flex items-center justify-center font-bold border-2 border-amber-300 text-sm sm:text-base">
            {(parent?.name || "P").charAt(0)}
          </div>
          {onLogout && (
            <button
              onClick={onLogout}
              className="hidden sm:block text-amber-200 hover:text-white text-sm font-medium transition-colors"
            >
              Sign Out
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
